import { flatten, forEach, map, reduce } from 'lodash';

export const mapListColumns = <T>(
  rows: (import('exceljs').CellValue | any[])[][]
) => {
  const expandedItems = map(rows, row => mapListItem(row));
  return flatten(expandedItems);
};

export const mapListItem = <T>(
  row: (import('exceljs').CellValue | any[])[]
): import('exceljs').CellValue[][] => {
  return reduce<
    (import('exceljs').CellValue | any[])[],
    import('exceljs').CellValue[][]
  >(
    row,
    (state, cell, columnIndex) => {
      const newState = [...state];
      if (Array.isArray(cell) && typeof cell !== 'string') {
        //append element in 2d array
        forEach(cell, (article, additionalRowIndex) => {
          if (!newState[additionalRowIndex]) {
            //@ts-ignore
            newState.push([...row]);
          }
          if (!newState[additionalRowIndex][columnIndex]) {
            newState[additionalRowIndex].push(article);
          } else {
            newState[additionalRowIndex][columnIndex] = article;
          }
        });
        return newState;
      }
      return state;
    },
    [row as unknown as import('exceljs').CellValue[]]
  );
};
